import { TaxBreakdownItem } from "@shared/schema";
import { Progress } from "@/components/ui/progress";

interface TaxBreakdownChartProps {
  breakdown: TaxBreakdownItem[];
  grossSalary: number;
  currencySymbol: string;
}

export function TaxBreakdownChart({ breakdown, grossSalary, currencySymbol }: TaxBreakdownChartProps) {
  const formatCurrency = (amount: number) => {
    return `${currencySymbol}${amount.toLocaleString("en-US", { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 0 
    })}`;
  };

  return (
    <div className="space-y-4">
      {breakdown.map((item, index) => (
        <div key={index} className="space-y-2">
          <div className="flex justify-between items-center text-sm">
            <span className="font-medium">{item.name}</span>
            <div className="flex items-center gap-2">
              <span className="font-mono text-muted-foreground">
                {item.percentage.toFixed(1)}%
              </span>
              <span className="font-mono font-semibold">
                {formatCurrency(item.amount)}
              </span>
            </div>
          </div>
          <div className="relative h-3 w-full overflow-hidden rounded-full bg-secondary">
            <div
              className="h-full transition-all duration-500 ease-out rounded-full"
              style={{ 
                width: `${Math.min((item.amount / grossSalary) * 100, 100)}%`,
                backgroundColor: item.color
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

interface TaxBreakdownListProps {
  breakdown: TaxBreakdownItem[];
  currencySymbol: string;
}

export function TaxBreakdownList({ breakdown, currencySymbol }: TaxBreakdownListProps) {
  const formatCurrency = (amount: number) => {
    return `${currencySymbol}${amount.toLocaleString("en-US", { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 0 
    })}`;
  };

  return (
    <div className="space-y-2">
      {breakdown.map((item, index) => (
        <div 
          key={index} 
          className="flex justify-between items-center py-2 border-b border-border last:border-0"
        >
          <div className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded-full" 
              style={{ backgroundColor: item.color }}
            />
            <span className="text-sm">{item.name}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-muted-foreground font-mono">
              {item.percentage.toFixed(1)}%
            </span>
            <span className="font-mono font-medium">
              {formatCurrency(item.amount)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
